import {BUSCAR_CONFIGURACOES_BPE} from '../../actions/configuracao-bpe/configuracaoBPeActions';

const initialState = {
  configuracoesBPe: null,
  configuracaoBPeSelecionada: null,

}

export default function reducerConfiguracaoBPe (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_CONFIGURACOES_BPE: {
      return {
        ...state,
        configuracoesBPe: action.payload.data
      }
    }

    default: {
      return state
    }
  }
}
